<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: $tc('messages.faction_sets', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.name')" for="name" />
                            <FormInput
                                required
                                id="name"
                                v-model="form.name"
                                name="name"
                                type="text"
                                max="191"
                                class="mt-1"
                            />
                            <FormError :value="form.errors.name" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $tc('messages.gamification_sets', 2) }}
                </template>
                <ul>
                    <li
                        v-for="gamificationSet in options.gamificationSets"
                        class="flex gap-x-2 items-center"
                        :key="gamificationSet.value"
                    >
                        <input
                            :id="`gamificationSet_${gamificationSet.value}`"
                            name="gamificationSet[]"
                            type="checkbox"
                            :value="gamificationSet.value"
                            v-model="form.gamification_set_ids"
                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        />
                        <span>{{ gamificationSet.text }}</span>
                        <span class="text-gray-500">({{ gamificationSet.grade_level_names }})</span>
                        <span class="text-gray-500" v-if="gamificationSet.faction_set_name"
                            >({{ gamificationSet.faction_set_name }})</span
                        >
                    </li>
                </ul>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                    {{ $t('messages.save') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
        AppButton,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'factionSet'],
    data() {
        return {
            form: this.$inertia.form({
                name: this.factionSet.name,
                gamification_set_ids: this.factionSet.gamification_set_ids,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
